import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, Contact } from "lucide-react";
import ContactInfo from "./ContactInfo";
import "./ContactView.css";

const ContactView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const contactData = location.state?.data;

  return (
    <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div className="ctv-header-banner">
        <button
          type="button"
          className="ctv-back-btn"
          onClick={() => navigate(-1)}
          aria-label="Back"
        >
          <ArrowLeft size={16} />
        </button>
        <span className="ctv-header-icon">
          <Contact size={14} color="#fff" />
        </span>
        <div>
          <div className="ctv-header-title">View Contact</div>
          <div className="ctv-header-subtitle">Contact details</div>
        </div>
      </div>
      <ContactInfo contactData={contactData} />
    </div>
  );
};

export default ContactView;
